export const CHANGE_CURRENCY = 'CHANGE_CURRENCY';
export const SET_CURRENCY_LIST = 'SET_CURRENCY_LIST';
export const GET_PAYMENT_CURRENCY = 'GET_PAYMENT_CURRENCY';

